import { DASHBOARD } from '../actions/types'

const initialState = {
    detalles: null,

    proyectosActivos: null,
    loadingProyectosActivos: false,
    errorProyectosActivos: false,

    ventasPeriodos: null,
    loadingVentasPeriodos: false,
    errorVentasPeriodos: false,

    ventas30Dias: null,
    loadingVentas30Dias: false,
    errorVentas30Dias: false,

    porCobrar: null,
    loadingPorCobrar: false,
    errorPorCobrar: false
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {

        case DASHBOARD.OBTENER:
            return {
                ...state,
                detalles: payload
            };

        case DASHBOARD.PROYECTOS_ACTIVOS_CARGANDO:
            return {
                ...state,
                loadingProyectosActivos: true,
                errorProyectosActivos: false
            };

        case DASHBOARD.PROYECTOS_ACTIVOS:
            return {
                ...state,
                proyectosActivos: payload,
                loadingProyectosActivos: false,
                errorProyectosActivos: false
            };

        case DASHBOARD.PROYECTOS_ACTIVOS_ERROR:
            return {
                ...state,
                loadingProyectosActivos: false,
                errorProyectosActivos: true
            };

        case DASHBOARD.VENTAS_PERIODOS_CARGANDO:
            return {
                ...state,
                loadingVentasPeriodos: true,
                errorVentasPeriodos: false
            };

        case DASHBOARD.VENTAS_PERIODOS:
            return {
                ...state,
                ventasPeriodos: payload,
                loadingVentasPeriodos: false,
                errorVentasPeriodos: false
            };

        case DASHBOARD.VENTAS_PERIODOS_ERROR:
            return {
                ...state,
                loadingVentasPeriodos: false,
                errorVentasPeriodos: true
            };

        case DASHBOARD.VENTAS_30_DIAS_CARGANDO:
            return {
                ...state,
                loadingVentas30Dias: true,
                errorVentas30Dias: false
            };

        case DASHBOARD.VENTAS_30_DIAS:
            return {
                ...state,
                ventas30Dias: payload,
                loadingVentas30Dias: false,
                errorVentas30Dias: false
            };

        case DASHBOARD.VENTAS_30_DIAS_ERROR:
            return {
                ...state,
                loadingVentas30Dias: false,
                errorVentas30Dias: true
            };

        case DASHBOARD.POR_COBRAR_CARGANDO:
            return {
                ...state,
                loadingPorCobrar: true,
                errorPorCobrar: false
            };

        case DASHBOARD.POR_COBRAR:
            return {
                ...state,
                porCobrar: payload,
                loadingPorCobrar: false,
                errorPorCobrar: false
            };

        case DASHBOARD.POR_COBRAR_ERROR:
            return {
                ...state,
                loadingPorCobrar: false,
                errorPorCobrar: true
            };

        default:
            return state;
    }

}
